/**
 * File: newsletter.js.
 *
 * Handles the newsletter form submission
 */

export default {
  newsletter: document.querySelector('.moa-newsletter'),
  adestra: {
    coreTableId: 48,
    listId: 8580,
  },
  init() {
    if (this.newsletter) {
      this.render();
    }
  },
  render() {
    const newsletterFormWrapper = this.newsletter.querySelector('.js-moa-newsletter-form');
    const newsletterForm = this.newsletter.querySelector('form');
    const newsletterTitle = this.newsletter.querySelector('.js-moa-newsletter-title > p > span');
    const spinner = document.querySelector('.js-spinner');

    if (! newsletterForm) {
      return;
    }

    newsletterForm.addEventListener('submit', (event) => {
      const email = this.newsletter.querySelector('.form-email');
      event.preventDefault();
      spinner.classList.add('loading');

      newsletterForm.querySelector('input[type="submit"]').disabled = true;
      if (email) {
        const _data = {
          table_id: this.adestra.coreTableId,
          contact_data: {
            email: email.value,
          },
          options: {
            list_id: this.adestra.listId,
          },
        };
        this.postRequest({ action: 'create_contact_newsletter', data: _data })
          .then((res) => res.text())
          .then((response) => {
            // Do something here
            // console.log(response);
            newsletterTitle.innerHTML = 'Thank you for submitting your email address!';
            newsletterFormWrapper.setAttribute('style', 'display:none');
            spinner.classList.remove('loading');
          });
      }
    });
  },
  postRequest({ action, data }) {
    const AJAX_URL = window.wpAjax.ajax_url;
    const FETCH_URL = AJAX_URL;
    const FETCH_OBJECT = {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      body: `action=${ action }&data=${ JSON.stringify(data) }`,
    };

    return fetch(FETCH_URL, FETCH_OBJECT);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
